import Vue from 'vue'

const vue = new Vue()

const apiURL = 'http://api.tachyondata.com'

export const post = (path, data) => {
  return vue.$http.post(`${apiURL}${path}`, data)
}



// WEBPACK FOOTER //
// ./src/apiHttp.js